module.exports = __webpack_public_path__ + "media/acuity/esg-d73c2c2b.svg";